<template>
	<div class="voice">
		<audio ref=audioBox :src="voiceUrl1" controls="controls" hidden="hidden">不支持</audio>
		<div class="voiceBox" @click="startPlay" v-if="who == 'himself'">
			<img class="img" src="./img/voicet.png" alt="" />
			<span>{{time}} s</span>
			<img v-show="gifShow" class="gif" src="./img/gif.gif" alt="" />
		</div>
		<div class="voiceBox1" @click="startPlay" v-if="who == 'myself'">
			<img class="img" src="./img/voicemy.png" alt="" />
			<span>{{time}} s</span>
			<img v-show="gifShow" class="gif" src="./img/voicegif.gif" alt="" />
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				msg:'',
				time:'',
				gifShow:false,
				voiceUrl1:''
			}
		},
		props:[
			'voiceUrl',
			'who'
		],

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		mounted(){
			this.getTime();
			this.voiceUrl1=this.voiceUrl +'.mp3'
		},
		methods:{
			langtrans(){
				return langtrans
			},
			getTime(){
				var radioBox = this.$refs.audioBox;
				var _this=this;
               if (radioBox != null) {
                    var duration;
                    radioBox.load();
                    radioBox.oncanplay = function () {
                        _this.time=radioBox.duration.toFixed(2)
                    }
                }
			},
			startPlay(){
				this.$refs.audioBox.play();
				this.gifShow=true;
				setTimeout(()=>{
					this.gifShow=false;
				},this.time * 1000)
			}
		}
	}
</script>

<style scoped="scoped">
	.voice{margin-top: 10px;height: 40px;overflow: hidden;}
	.voiceBox{overflow: hidden;position: relative;}
	.voiceBox .gif{position: absolute;top: 11px;left: 15px;}
	.voiceBox .img{float: left;cursor: pointer;}
	.voiceBox span{float: left;margin-top: 10px;margin-left: 10px;}
	.voiceBox1{float: right;position: relative;}
	.voiceBox1 span{float: left;margin-top: 14px;margin-right: 10px;}
	.voiceBox1 .gif{position: absolute;top: 11px;right: 16px;}
</style>



// WEBPACK FOOTER //
// src/views/commonPage/voice.vue